import { render, staticRenderFns } from "./BioSummary.vue?vue&type=template&id=3a6a83e0&scoped=true"
import script from "./BioSummary.vue?vue&type=script&lang=js"
export * from "./BioSummary.vue?vue&type=script&lang=js"
import style0 from "./BioSummary.vue?vue&type=style&index=0&id=3a6a83e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a83e0",
  null
  
)

export default component.exports